exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-invalid[data-v-dbc6a36e] {\n  border: 1px solid #dc3545;\n  color: #dc3545;\n}\n.is-invalid-checkbox[data-v-dbc6a36e] {\n  color: #dc3545;\n}\nbutton[type=\"submit\"][data-v-dbc6a36e]:disabled {\n  color: #fff;\n}\n.alert[data-v-dbc6a36e] {\n  font-size: 1.6rem;\n}\n.invalid-feedback-head[data-v-dbc6a36e] {\n  position: relative;\n}\n.invalid-feedback[data-v-dbc6a36e] {\n  position: absolute;\n  top: -1.5rem;\n  left: 0;\n  width: 100%;\n}\n.invalid-feedback--policy[data-v-dbc6a36e] {\n  display: block;\n  text-align: center;\n  top: auto;\n  bottom: -15px;\n}\n", ""]);

// exports
